export const supplierStatus = {
    26: 'supplier_active',
    27: 'supplier_inactive',
};
